import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatIcon } from '@angular/material/icon';
import {
  TickCrossRendererParams,
  tickCrossValue,
  TickCrossValue,
} from './tick-cross-renderer.types';

@Component({
  selector: 'app-tick-cross-renderer',
  imports: [MatIcon],
  templateUrl: './tick-cross-renderer.component.html',
  styleUrls: ['./tick-cross-renderer.component.scss'],
})
export class TickCrossRendererComponent implements ICellRendererAngularComp {
  value = TickCrossValue.empty;
  TickCrossValue = TickCrossValue;
  valueIcon = {
    [TickCrossValue.empty]: '',
    [TickCrossValue.tick]: 'check',
    [TickCrossValue.cross]: 'close',
  };

  agInit(params: TickCrossRendererParams): void {
    this.value = tickCrossValue(params.value, params.config);
  }
  refresh(params: TickCrossRendererParams): boolean {
    this.value = tickCrossValue(params.value, params.config);
    return true;
  }
}
